// Algolia Search



var sliders = {};

var facetsShown = true;
var mobileFacetsShown = false;

function closeAllFacets(){
  const buttons = document.getElementsByClassName('ais-facet-title');
    for (let i=0; i<buttons.length;i++){
      buttons[i].classList.remove('open');
      const facetName = buttons[i].getAttribute("data");
      document.getElementById(`ais-facet-dropdown_${facetName}`).classList.remove('open');
  }
}


function loadFacets(){
  
  //connect facet buttons to event handlers
const facetButtons = document.getElementsByClassName('ais-facet-title');
for (let i=0; i<facetButtons.length; i++){
  const button = facetButtons[i];
  const facetName = button.getAttribute("data");
  const initialised = button.getAttribute("initialised");

  const left = button.getBoundingClientRect().left;

  const dropdown = document.getElementById(`ais-facet-dropdown_${facetName}`);
  

  if (facetName && initialised == "false"){
    button.setAttribute("initialised", true);
    button.addEventListener('click', function(){

      if (dropdown.classList.contains('open')){
        closeAllFacets();
      }
      else {
        closeAllFacets();
        button.classList.add('open');
        dropdown.classList.add('open');
      }
    })

  }
}

  document.body.addEventListener('click', function(e){
    if (!e.target.classList.contains('ais-facet-title')){
      closeAllFacets()
    }
  });
}



function toggleFacets(){

    if (facetsShown == false){
      $('#ais-block-container').addClass('condensed');
      $('#ais-facet-container').addClass('open');
      
      setTimeout(function(){
        $('#ais-facet-container').addClass('sticky');
        $('#ais-facets-button').addClass('on');
      },500)
      
      
      facetsShown = true;
    }
  else {
    $('#ais-block-container').removeClass('condensed');
    $('#ais-facet-container').removeClass('open');
    $('#ais-facet-container').removeClass('sticky');
    $('#ais-facets-button').removeClass('on');
    facetsShown = false;
  }
}

function toggleMobileFacets(){
    if (mobileFacetsShown == false){
      document.getElementById('ais-facet-container').classList.add('open');
      document.getElementById('close-mobile-facets').classList.add('visible');
      document.getElementById('facet-drawer-overlay').classList.add('on');
      mobileFacetsShown = true;
    }
  else {
    document.getElementById('ais-facet-container').classList.remove('open');
    document.getElementById('close-mobile-facets').classList.remove('visible');
    document.getElementById('facet-drawer-overlay').classList.remove('on');
    mobileFacetsShown = false;
  } 
}
//end search